/* eslint-disable react-hooks/exhaustive-deps */
import {logging} from "@/utils/functions";
import {Box, Tab, Tabs} from "@mui/material";
import React, {useEffect, useMemo} from "react";
import {resolveCustomerTeam} from "@/services/customer.ts";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import TeamInvitation from "./TeamInvitation";
import TeamInvited from "./TeamInvited";
import TeamOwned from "./TeamOwned";
import {LoadingDotBox} from "@/components/Shared/LoadingBox.tsx";
import TabPanel from "@/components/Shared/TabPannel";
import Utils from "@/components/Shared/Utils";
import UICard, {UICardContent, UICardHeadingLight} from "@/components/Shared/Utils/UICard";

export default function OrganizationOverview({customer, user, invitation}: any) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const hash = useMemo(() => location.hash?.toString()?.replace('#', ''), [location]);
    const [value, setValue] = React.useState(() => ['owned', 'invited'].includes(hash) ? hash : 'owned');
    const active = useMemo(() => params["*"] || null, [params]);

    const {data: team, refetch} = resolveCustomerTeam(user);

    const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    useEffect(() => {
        logging('OrganizationOverview ▶ User', user)
        logging('OrganizationOverview ▶ Team', team)
    }, [])

    return (
        <>
            <Utils.LayoutUtils.MainContainer modal={active !== null && team}>
                <Utils.LayoutUtils.MainWrapper>
                    <Utils.LayoutUtils.MainHeading title="Organization"/>
                    <UICard gradient>
                        <UICardHeadingLight title="Team Information"
                                            description="Your key contact information for accessing our support and sales teams."/>
                        <UICardContent>
                            <Tabs value={value} onChange={handleChange} sx={{minHeight: 'unset'}}
                                  TabIndicatorProps={{
                                      style: {transition: 'none'}
                                  }} aria-label="basic tabs teammate"
                            >
                                <Tab sx={{
                                    p: 0.5,
                                    px: 1.5,
                                    minHeight: 42,
                                    fontSize: 14,
                                    textTransform: 'capitalize',
                                    marginBottom: '-2px'
                                }} label="Owned by You" value="owned"/>
                                <Tab sx={{
                                    p: 0.5,
                                    px: 1.5,
                                    minHeight: 42,
                                    fontSize: 14,
                                    textTransform: 'capitalize',
                                    marginBottom: '-2px'
                                }} label="You're Invited" value="invited"/>
                            </Tabs>
                            <React.Suspense fallback={
                                <Box bgcolor="white">
                                    <LoadingDotBox/>
                                </Box>
                            }>
                                <TabPanel active={value} index="owned">
                                    <TeamOwned customer={customer} user={user}/>
                                </TabPanel>
                                <TabPanel active={value} index="invited">
                                    <TeamInvited user={user} invitation={invitation}/>
                                </TabPanel>
                            </React.Suspense>
                        </UICardContent>
                    </UICard>
                </Utils.LayoutUtils.MainWrapper>
            </Utils.LayoutUtils.MainContainer>
            <React.Suspense fallback={<LoadingDotBox/>}>
                {active && active === 'teams/invitation' && team && (
                    <TeamInvitation
                        user={user}
                        team={team}
                        refetchTeamOverview={refetch}
                        close={() => [navigate("/account/organization#teams")]}
                    />
                )}
            </React.Suspense>
        </>
    )
}